export const isDisplay = (value) => value === 'display' || value === true;
